import { useEffect, useRef } from 'react';
import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const indicatorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = indicatorRef.current;
    if (!el) return;
    let interval: ReturnType<typeof setInterval>;
    const animate = () => {
      el.style.transition = 'transform 0.75s ease-in-out';
      el.style.transform = 'translateY(8px)';
      setTimeout(() => {
        el.style.transform = 'translateY(0)';
      }, 750);
    };
    animate();
    interval = setInterval(animate, 1500);
    return () => clearInterval(interval);
  }, []);

  const scrollDown = () => {
    const target = document.querySelector('#projetos');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroData.bgImage}
          alt="Interior sofisticado"
          className="w-full h-full object-cover object-top brightness-[0.75]"
        />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-[900px] mx-auto">
        <p className="font-body text-white/80 text-sm md:text-base font-light tracking-[0.12em] uppercase mb-6 md:mb-8">
          {heroData.subtitle}
        </p>
        <h1 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extralight leading-[1.15] tracking-tight mb-10 md:mb-14">
          {heroData.title}
        </h1>
        <a
          href="#contato"
          onClick={(e) => {
            e.preventDefault();
            const el = document.querySelector('#contato');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="inline-flex items-center justify-center px-8 py-3.5 text-sm font-light text-black bg-white rounded-full hover:bg-white/90 transition-colors duration-300 whitespace-nowrap"
        >
          {heroData.cta}
        </a>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollDown}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 text-white cursor-pointer group"
      >
        <span className="font-body text-xs font-light uppercase tracking-[0.15em] opacity-70 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
          Explorar
        </span>
        <div ref={indicatorRef} className="w-px h-8 bg-white/50" />
      </button>
    </section>
  );
}